import React from 'react';
export function Footer() {
  return <footer className="bg-navyDark text-white/60 py-10 px-4 text-center text-sm" data-id="element-85">
      <div className="max-w-4xl mx-auto space-y-2" data-id="element-86">
        <p data-id="element-87">© 2024 El Acelerador 24H — Todos los derechos reservados</p>
        <p data-id="element-88">Dra. Elena Martínez Solís — Col. Nº AND-4821</p>
        <p className="text-white/40 mt-4 text-xs" data-id="element-89">
          * Los resultados pueden variar según cada persona. Este producto no
          sustituye el consejo médico profesional.
        </p>
      </div>
    </footer>;
}